import React from 'react';
import { getDomainConfig } from '../config';
import './LegalPage.css';

function PrivacyPage() {
  const config = getDomainConfig();
  const domain = window.location.hostname;

  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last Updated: October 2025</p>

      <div className="legal-content">
        <section>
          <h2>1. Information We Collect</h2>
          <p>
            {config.name} ("we," "our," or "us") collects information that you provide directly to us,
            including when you create an account, make a purchase, or contact us.
          </p>
          <p>Information we collect includes:</p>
          <ul>
            <li>Name, email address, and contact information</li>
            <li>Company name and business information</li>
            <li>Billing and shipping addresses</li>
            <li>Payment information (processed securely by third-party providers)</li>
            <li>Product preferences and search history</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about products, services, and promotions</li>
            <li>Improve our website and services</li>
            <li>Prevent fraud and ensure security</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell your personal information. We may share your information with:
          </p>
          <ul>
            <li>Suppliers and manufacturers to fulfill your orders</li>
            <li>Service providers who assist in operating our website</li>
            <li>Law enforcement when required by law</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies and Tracking</h2>
          <p>
            We use cookies and similar technologies to enhance your browsing experience,
            analyze site traffic, and understand user preferences.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your
            personal information against unauthorized access, alteration, or destruction.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Opt-out of marketing communications</li>
            <li>Object to certain data processing</li>
          </ul>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at:
          </p>
          <p>Email: privacy@{domain}</p>
          <p>Phone: 1-800-PRIVACY</p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPage;
